import Crying from '@direct-frontend/components/src/icons/illustrated/Character/CharacterCrying.svg';
import { ErrorBlank } from '../../ErrorBlank';
import { withImage } from '../../lib/hoc/withImage';

/**
 * Компонент отображения ошибок с подставленным изображением Crying
 * @kind component
 */
export const ErrorBlankTears = withImage(ErrorBlank, {
    imageSrc: Crying,
    imageAlt: 'Ошибка',
});
